import { REQUESTS_ACTIONS } from "./REQUESTS_ACTIONS"


export function requestsReducer(state, action) {
  switch (action.type) {
    case REQUESTS_ACTIONS.SET_REQUESTS:
      return {
        ...state,
        requests: action.payload.requests,
        pagination: action.payload.pagination,
      }
    case REQUESTS_ACTIONS.SET_IS_LOADING:
      return { ...state, isLoading: action.payload.isLoading }
    default:
      return state
  }
}